module.exports = __webpack_public_path__ + "img/Classifier5.d0686342.png";